/* eslint-disable no-console */
/* eslint-disable no-async-promise-executor */
import { apiRoutes, serverUrl } from '../constants/api-routes';
import { getRequest, postRequest } from '../config/axios-config';
import { ApiResponse } from '../types/api';
import {
  ChallengeApplicationEligibilityBody,
  ChallengeApplicationEligibilityStatus,
  ChallengeApplicationPage,
  ChallengeApplicationResponse,
  CreateChallengeApplicationBody,
} from '../types/challenges';

const verifyInboundEnabled = (suffix: string) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.verifyInboundEnabled}/${suffix}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const checkApplicationExists = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.checkApplicationExists,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const createInboundApplication = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.createInboundApplication,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getInboundBuilderDetails = (suffix: string) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getInboundBuilderDetails}/${suffix}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getProductListInfo = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getProductListInfo,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
const getPrimaryInboundFromSubdomain = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getPrimaryInboundFromSubdomain,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getLogPostList = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getLogPostList,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const addLogPost = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.addLogPost,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const addLogStory = (body: object, headers?: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.addLogStory,
        body,
        headers
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getChallengeApplicationPage = (challengeId: string) =>
  new Promise<ApiResponse<ChallengeApplicationPage>>(async (resolve, reject) => {
    try {
      const response = (await getRequest(
        `${
          serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.challengeApplication
        }/${challengeId}/application`
      )) as ApiResponse<ChallengeApplicationPage>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const checkChallengeApplicationEligibility = (challengeId: string, body: ChallengeApplicationEligibilityBody) =>
  new Promise<ApiResponse<{ status: ChallengeApplicationEligibilityStatus }>>(async (resolve, reject) => {
    try {
      const response = (await postRequest(
        `${
          serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.challengeApplication
        }/${challengeId}/application/eligibility`,
        body
      )) as ApiResponse<{ status: ChallengeApplicationEligibilityStatus }>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const createChallengeApplication = (challengeId: string, body: CreateChallengeApplicationBody) =>
  new Promise<ApiResponse<ChallengeApplicationResponse>>(async (resolve, reject) => {
    try {
      const response = (await postRequest(
        `${
          serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.challengeApplication
        }/${challengeId}/application`,
        body
      )) as ApiResponse<ChallengeApplicationResponse>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

export {
  getChallengeApplicationPage,
  checkChallengeApplicationEligibility,
  createChallengeApplication,
  verifyInboundEnabled,
  checkApplicationExists,
  createInboundApplication,
  getInboundBuilderDetails,
  getPrimaryInboundFromSubdomain,
  getProductListInfo,
  getLogPostList,
  addLogPost,
  addLogStory,
};
